import { render } from "./TaskFieldTable.vue?vue&type=template&id=04ec35b6&ts=true"
import script from "./TaskFieldTable.vue?vue&type=script&lang=ts"
export * from "./TaskFieldTable.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__